export default function MenuShare(){
  return (
    <>
      <div id="kids" className="cbp-caption kids">
        <div className="cbp-caption-defaultWrap"><h4>Kids Menu</h4></div>

        <div className="cbp-caption-activeWrap">
          <div className="cbp-l-caption-body">
            <div className="menu-item">
              <h4>Pizza <span>... $7</span></h4>
              <p>Pepperoni, Sausage, or Cheese</p>
            </div>

            <div className="menu-item">
              <h4>Burger &amp; Chips <span>... $7</span></h4>
              <p>Plain or with Cheese</p>
            </div>

            <div className="menu-item"><h4>Chicken Tenders &amp; Chips <span>... $7</span></h4></div>

            <div className="menu-item">
              <h4>Kids Pasta <span>... $7</span></h4>
              <p> In Your Choice of Butter, Alfredo Sauce, or Marinara Sauce</p>
            </div>

            <div className="menu-item"><h4>Chicken Alfredo <span>... $7</span></h4></div>

            <div className="menu-item"><h4>Fruit Plate <span>... $7</span></h4></div>
          </div>
        </div>
      </div>

      <div id="dessert" className="cbp-caption desserts">
        <div className="cbp-caption-defaultWrap"><h4>Dessert Menu</h4></div>

        <div className="cbp-caption-activeWrap">
          <div className="cbp-l-caption-body">
            <div className="menu-item">
              <h4>Classic Tiramisu <span>... $8</span></h4>
            </div>

            <div className="menu-item">
              <h4>Chef's Choice Chocolate Cake <span>... $8</span></h4>
            </div>

            <div className="menu-item">
              <h4>Carrot Cake <span>... $8</span></h4>
            </div>

            <div className="menu-item">
              <h4>Chef's Choice Cheesecake<span>... $8</span></h4>
            </div>

            <div className="menu-item">
              <h4>Crème Brulee<span>... $8</span></h4>
            </div>

            <div className="menu-item">
              <h4>Coconut Cake<span>... $8</span></h4>
            </div>
          </div>
        </div>
      </div>

      <div id="familyMeals" className="cbp-caption family">
        <div className="cbp-caption-defaultWrap"><h4>Family Meals To Go</h4></div>

        <div className="cbp-caption-activeWrap">
          <div className="cbp-l-caption-body">
              <div className="menu-item"><p><b>Feeds 4 People. All Family Meals Served with a House or Caesar Salad, and House Made Focaccia Bread.</b></p></div>

              <div className="menu-item uno">
                <h4>10 Layer Lasagna... $42</h4>
                <p>Beef and Pork Lasagna, Layered with Ricotta Béchamel, House Made Marinara and Mozzarella</p>
              </div>
              <div className="menu-item">
                <h4>Shrimp or Chicken Alfredo... $42</h4>
                <p>Grilled Chicken or Shrimp, House Made Alfredo, Spinach, Fettuccine Noodle</p>
              </div>
              <div className="menu-item">
                <h4>Grilled Salmon... $56</h4>
                <p>Served with Tomato Risotto, Green Beans, and Balsamic Glaze</p>
              </div>

              <div className="menu-item">
                <h4>Spicy Rigatoni... $50</h4>
                <p>Italian Sausage, Calabrian Chili, Arrabbiata Sauce and Garlic Pangrattato</p>
              </div>

              <div className="menu-item">
                <h4>Add a Bottle of Wine for $18</h4>
                <p>(Select Wines Only)</p>
              </div>

          </div>
        </div>
      </div>
    </>
  )
}